export default function OneObjective({ content, icon }) {
  return (
    <div className="tff-objective-card ">
      <div className="tff-objective-icon">{icon}</div>
      <div className="font-semi-bold tff-objective-text">{content}</div>
    </div>
  );
}
